export const SELECTED_SINGIN_FORM = 'SELECTED_SINGIN_FORM';
export const SIGN_IN_REQUEST = 'SIGN_IN_REQUEST';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE';
export const SIGN_IN_ERROR_CLEAN = 'SIGN_IN_ERROR_CLEAN';
export const SIGN_OUT = 'SIGN_OUT';
export const CURRENT_USER = 'CURRENT_USER';
